var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_675_12384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46.1075,
    r: 45.5498,
    fill: "#CAF9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.508 51.7916C62.8417 51.2985 63.9924 50.4086 64.8049 49.2416C65.6174 48.0746 66.0528 46.6866 66.0523 45.2646V40.9168C66.0523 40.4556 65.8691 40.0132 65.543 39.6871C65.2168 39.3609 64.7745 39.1777 64.3132 39.1777H60.7515",
    stroke: "#49AA7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5971 51.7916C29.2633 51.2985 28.1127 50.4086 27.3002 49.2416C26.4877 48.0746 26.0523 46.6866 26.0527 45.2646V40.9168C26.0527 40.4556 26.236 40.0132 26.5621 39.6871C26.8883 39.3609 27.3306 39.1777 27.7919 39.1777H31.3588",
    stroke: "#49AA7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6948 30.5255C61.7006 30.2935 61.6599 30.0627 61.5751 29.8466C61.4903 29.6306 61.3631 29.4337 61.201 29.2676C61.039 29.1014 60.8453 28.9694 60.6314 28.8793C60.4175 28.7892 60.1878 28.7428 59.9557 28.7429H32.1713C31.9392 28.7428 31.7095 28.7892 31.4956 28.8793C31.2817 28.9694 31.088 29.1014 30.9259 29.2676C30.7639 29.4337 30.6367 29.6306 30.5519 29.8466C30.4671 30.0627 30.4264 30.2935 30.4322 30.5255C31.0357 55.2455 44.2635 48.1829 44.2635 57.4386C44.1678 62.8299 41.9174 64.8107 38.0652 65.1934C37.6348 65.2366 37.2359 65.4388 36.9464 65.7604C36.657 66.0819 36.4978 66.4998 36.5 66.9325V67.0038C36.5 67.465 36.6832 67.9074 37.0094 68.2335C37.3355 68.5597 37.7779 68.7429 38.2391 68.7429H53.8913C54.3526 68.7429 54.7949 68.5597 55.1211 68.2335C55.4472 67.9074 55.6304 67.465 55.6304 67.0038V66.9238C55.6326 66.4912 55.4734 66.0732 55.184 65.7517C54.8946 65.4301 54.4957 65.2279 54.0652 65.1847C50.1644 64.8125 47.7418 62.8299 47.7418 57.4386C47.7418 48.1725 61.0844 55.1377 61.6948 30.5255Z",
    stroke: "#49AA7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6423 32.5499C45.6665 32.4563 45.7212 32.3733 45.7977 32.3141C45.8742 32.2549 45.9682 32.2227 46.0649 32.2227C46.1616 32.2227 46.2556 32.2549 46.3321 32.3141C46.4086 32.3733 46.4633 32.4563 46.4875 32.5499L47.804 37.4386H53.324C53.4172 37.4389 53.5079 37.4691 53.5826 37.5248C53.6574 37.5805 53.7122 37.6587 53.7391 37.748C53.766 37.8372 53.7635 37.9327 53.732 38.0204C53.7005 38.1082 53.6416 38.1834 53.564 38.2351L49.5414 41.1603L51.6493 46.7812C51.6821 46.8686 51.686 46.9642 51.6604 47.054C51.6347 47.1437 51.5808 47.2228 51.5067 47.2796C51.4326 47.3364 51.3422 47.3677 51.2488 47.3691C51.1555 47.3705 51.0642 47.3418 50.9884 47.2873L46.0614 43.769L41.1345 47.2873C41.0587 47.3418 40.9674 47.3705 40.874 47.3691C40.7807 47.3677 40.6903 47.3364 40.6162 47.2796C40.542 47.2228 40.4882 47.1437 40.4625 47.054C40.4368 46.9642 40.4407 46.8686 40.4736 46.7812L42.5745 41.1603L38.5588 38.2351C38.4813 38.1834 38.4224 38.1082 38.3909 38.0204C38.3593 37.9327 38.3568 37.8372 38.3837 37.748C38.4106 37.6587 38.4655 37.5805 38.5402 37.5248C38.6149 37.4691 38.7056 37.4389 38.7988 37.4386H44.3136L45.6423 32.5499Z",
    stroke: "#49AA7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_675_12384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.0996,
    height: 91.0996,
    fill: "white",
    transform: "translate(0.450195 0.557739)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.9caef96d320fa3c5e4659ceb0c1e9fff.svg";
export { ForwardRef as ReactComponent };